export const SuperAdminActionTypes = {
  SUPER_ADMIN_SET_CUSTOMER: '@@superAdmin/set'
}

export const superAdminActionSetCustomer = (customer: string) => ({
  type: SuperAdminActionTypes.SUPER_ADMIN_SET_CUSTOMER,
  payload: {
    customerOverride: customer
  }
})